import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=36c1e760&scoped=true&"
import script from "./courseDetails.js?vue&type=script&lang=js&"
export * from "./courseDetails.js?vue&type=script&lang=js&"
import style0 from "./CourseDetails.vue?vue&type=style&index=0&id=36c1e760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1e760",
  null
  
)

export default component.exports